import './MainTitle.css';
import React from 'react';
import Link from 'redux-first-router-link';

import config from '@config';

const MainTitle = () => (
  <div className="maintitle">
    <Link to={['']} className="prode-logo-header">
      <img src={`${config.basePath}/img/logo-prode-sticker.svg`} alt="Prode 2026" />
    </Link>
  </div>
);

MainTitle.displayName = 'MainTitle';

export default MainTitle;
